import { AdminIdeasPostRequest } from '../post'

export class AdminIdeasDraftPostRequest extends AdminIdeasPostRequest {}
